/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'

import { useActiveClinic } from '@modules/active-clinic/core/ActiveClinicProvider'
import { useAuth } from '@modules/auth/contexts/AuthContext'

export const ActiveClinicSwitcher = () => {
  const { currentUser } = useAuth()
  const { activeClinic, setActiveClinic } = useActiveClinic()

  if (!currentUser || (currentUser && !activeClinic)) {
    return null
  }

  return (
    <>
      {/* begin::Menu toggle */}
      <a
        href="#"
        className="btn fw-normal bg-body btn-color-gray-600 btn-active-color-primary h-40px form-select border-0 pe-15 d-flex align-items-center"
        data-kt-menu-trigger="click"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-end"
      >
        <i className="fa-solid fa-house-chimney-medical fs-6 me-2" />
        {activeClinic?.name}
      </a>
      {/* end::Menu toggle */}

      {/* begin::Menu */}
      <div
        className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-normal py-4 fs-base w-250px"
        data-kt-menu="true"
      >
        {/* begin::Menu item */}
        {currentUser.clinics?.map((clinic) => (
          <div
            className="menu-item px-3 my-0"
            key={clinic.id}
          >
            <div
              className={clsx('menu-link px-3 py-2', {
                active: clinic.id === activeClinic?.id,
              })}
              onClick={() => setActiveClinic(clinic.id)}
            >
              <span className="menu-text">{clinic.name}</span>
            </div>
          </div>
        ))}
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}
